












import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  checked: boolean
}>(
  {
    props: ['checked'],
  },
  () => class {},
)
